import { createAsyncActionTypes } from '../../helpers';

const domain = 'books';

const submitBookDraftToEditorByWriter = createAsyncActionTypes(domain, 'submitBookDraftToEditorByWriter');
const submitBookDraftToEditorByDevelopmentalEditor = createAsyncActionTypes(domain, 'submitBookDraftToEditorByDevelopmentalEditor');
const sendBookDraftToCustomerByEditor = createAsyncActionTypes(domain, 'sendBookDraftToCustomerByEditor');
const approveBookDraftByCustomer = createAsyncActionTypes(domain, 'approveBookDraftByCustomer');
const sendBookDraftCustomerFeedback = createAsyncActionTypes(domain, 'sendBookDraftCustomerFeedback');
const sendBookDraftEditorFeedback = createAsyncActionTypes(domain, 'sendBookDraftEditorFeedback');
const sendBookOutlineEditorFeedback = createAsyncActionTypes(domain, 'sendBookOutlineEditorFeedback');
const sendBookOutlineCustomerFeedback = createAsyncActionTypes(domain, 'sendBookOutlineCustomerFeedback');
const sendBookOutlineWriterFeedback = createAsyncActionTypes(domain, 'sendBookOutlineWriterFeedback');
const updateSpecificField = createAsyncActionTypes(domain, 'updateSpecificField');
const sendDraftToCustomerByWriter = createAsyncActionTypes(domain, 'sendDraftToCustomerByWriter');
const sendPDFToMyEmail = createAsyncActionTypes(domain, 'sendPDFToMyEmail');
const saveUserIdWhoReadNotificationDraftWasEdited = createAsyncActionTypes(domain, 'saveUserIdWhoReadNotificationDraftWasEdited');
const addCommentToBookSample = createAsyncActionTypes(domain, 'addCommentToBookSample');
const deleteCommentInBookSample = createAsyncActionTypes(domain, 'deleteCommentInBookSample');
const resolveCommentInBookSample = createAsyncActionTypes(domain, 'resolveCommentInBookSample');
const updateCommentInBookSample = createAsyncActionTypes(domain, 'updateCommentInBookSample');
const addReplyToCommentInBookSample = createAsyncActionTypes(domain, 'addReplyToCommentInBookSample');
const updateReplyToCommentInBookSample = createAsyncActionTypes(domain, 'updateReplyToCommentInBookSample');
const deleteOrUndoComments = createAsyncActionTypes(domain, 'deleteOrUndoComments');
const sendPDFToPrinter = createAsyncActionTypes(domain, 'sendPDFToPrinter');
const getBookAndResourcesByProjectId = createAsyncActionTypes(domain, 'getBookAndResourcesByProjectId');
const getBookAndResourcesByCustomerId = createAsyncActionTypes(domain, 'getBookAndResourcesByCustomerId');
const approveCoverByCustomer = createAsyncActionTypes(domain, 'approveCoverByCustomer');
const completeInterviewStage = createAsyncActionTypes(domain, 'completeInterviewStage');
const approveFinalProofByCustomer = createAsyncActionTypes(domain, 'approveFinalProofByCustomer');
const approveFinalProofByEditor = createAsyncActionTypes(domain, 'approveFinalProofByEditor');

const approveOutlineByEditor = createAsyncActionTypes(domain, 'approveOutlineByEditor');
const approveOutlineByCustomer = createAsyncActionTypes(domain, 'approveOutlineByCustomer');
const submitOutlineByWriter = createAsyncActionTypes(domain, 'submitOutlineByWriter');
const editorSendDraftToDevelopmentalEditor = createAsyncActionTypes(domain, 'editorSendDraftToDevelopmentalEditor');
const editorSendDraftToProProofreader = createAsyncActionTypes(domain, 'editorSendDraftToProProofreader');
const uploadDocumentToGoogleDocx = createAsyncActionTypes(domain, 'uploadDocumentToGoogleDocx');

// Related to Cover Creator2.0
const updateCoverCopy = createAsyncActionTypes(domain, 'updateCoverCopy');
const updateCoverOptions = createAsyncActionTypes(domain, 'updateCoverOptions');

const onCloseOnboardingFeedbackModal = createAsyncActionTypes(domain, 'onCloseOnboardingFeedbackModal');
const addCommentToField = createAsyncActionTypes(domain, 'addCommentToField');
const deleteCommentByFieldName = createAsyncActionTypes(domain, 'deleteCommentByFieldName');
const resolveCommentByFieldName = createAsyncActionTypes(domain, 'resolveCommentByFieldName');
const updateCommentByFieldName = createAsyncActionTypes(domain, 'updateCommentByFieldName');
const addReplyToCommentByFieldName = createAsyncActionTypes(domain, 'addReplyToCommentByFieldName');
const updateReplyToCommentByFieldName = createAsyncActionTypes(domain, 'updateReplyToCommentByFieldName');
const saveBookSampleChanges = createAsyncActionTypes(domain, 'saveBookSampleChanges');
const approveBookSampleByCustomer = createAsyncActionTypes(domain, 'approveBookSampleByCustomer');
const saveStyleSamplesChanges = createAsyncActionTypes(domain, 'saveStyleSamplesChanges');
const approveStyleSampleByCustomer = createAsyncActionTypes(domain, 'approveStyleSampleByCustomer');

const approveSampleByWriter = createAsyncActionTypes(domain, 'approveSampleByWriter');
const approveSampleByEditor = createAsyncActionTypes(domain, 'approveSampleByEditor');
const submitSpecification = createAsyncActionTypes(domain, 'submitSpecification');
const saveSpecification = createAsyncActionTypes(domain, 'saveSpecification');

const uploadCustomPDF = createAsyncActionTypes(domain, 'uploadCustomPDF');
const uploadCustomCover = createAsyncActionTypes(domain, 'uploadCustomCover');
const addCommentToPDF = createAsyncActionTypes(domain, 'addCommentToPDF');
const resolvePdfComment = createAsyncActionTypes(domain, 'resolvePdfComment');
const deletePdfComment = createAsyncActionTypes(domain, 'deletePdfComment');
const addReplyToPdfComment = createAsyncActionTypes(domain, 'addReplyToPdfComment');
const editPdfComment = createAsyncActionTypes(domain, 'editPdfComment');

const approveDraftByContentTeam = createAsyncActionTypes(domain, 'approveDraftByContentTeam');

const submitBookDraftToEditorByProProofreader = createAsyncActionTypes(domain, 'submitBookDraftToEditorByProProofreader');

const proofRequestReview = createAsyncActionTypes(domain, 'proofRequestReview');

export default {
  submitBookDraftToEditorByWriter,
  submitBookDraftToEditorByDevelopmentalEditor,
  sendBookDraftToCustomerByEditor,
  approveBookDraftByCustomer,
  sendBookDraftCustomerFeedback,
  sendBookDraftEditorFeedback,
  sendBookOutlineEditorFeedback,
  sendBookOutlineCustomerFeedback,
  sendBookOutlineWriterFeedback,
  updateSpecificField,
  sendDraftToCustomerByWriter,
  sendPDFToMyEmail,
  saveUserIdWhoReadNotificationDraftWasEdited,
  addCommentToBookSample,
  deleteCommentInBookSample,
  resolveCommentInBookSample,
  updateCommentInBookSample,
  addReplyToCommentInBookSample,
  updateReplyToCommentInBookSample,
  deleteOrUndoComments,
  sendPDFToPrinter,
  getBookAndResourcesByProjectId,
  getBookAndResourcesByCustomerId,
  approveCoverByCustomer,
  completeInterviewStage,
  approveOutlineByEditor,
  approveOutlineByCustomer,
  submitOutlineByWriter,
  approveFinalProofByCustomer,
  approveFinalProofByEditor,
  editorSendDraftToDevelopmentalEditor,
  editorSendDraftToProProofreader,
  uploadDocumentToGoogleDocx,
  updateCoverCopy,
  updateCoverOptions,
  onCloseOnboardingFeedbackModal,
  addCommentToField,
  deleteCommentByFieldName,
  resolveCommentByFieldName,
  updateCommentByFieldName,
  addReplyToCommentByFieldName,
  updateReplyToCommentByFieldName,
  saveBookSampleChanges,
  approveBookSampleByCustomer,
  saveStyleSamplesChanges,
  approveStyleSampleByCustomer,
  approveSampleByWriter,
  approveSampleByEditor,
  submitSpecification,
  saveSpecification,
  uploadCustomPDF,
  uploadCustomCover,
  addCommentToPDF,
  resolvePdfComment,
  deletePdfComment,
  addReplyToPdfComment,
  editPdfComment,
  approveDraftByContentTeam,
  submitBookDraftToEditorByProProofreader,
  proofRequestReview,
};
